export const FETCH_POST_MESSAGE = 'fetchPutMessage'
export const FETCH_MESSAGES_LIST = 'fetchMessagesList'
export const FETCH_MESSAGE = 'fetchMessage'
export const FETCH_THREADS = 'fetchThreads'
